"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("../../common");
const domain_1 = require("@home-health-notify/domain");
exports.default = {
    type: "VerticalLayout",
    elements: [
        {
            type: "Control",
            label: "Select Action",
            scope: "#/properties/action",
            options: {
                format: "dropdown",
                oneOfStyle: {
                    SCHEDULE_VISIT: {
                        color: "#43a447",
                    },
                    CANCEL_VISIT: {
                        color: "#f44336",
                    },
                },
            },
        },
        {
            type: "VerticalLayout",
            rule: {
                effect: "HIDE",
                condition: {
                    scope: "#/properties/action",
                    schema: { const: "CANCEL_VISIT" },
                },
            },
            elements: [
                (0, common_1.makeAppointmentUiSchema)("futureAppointment", "Visit", {
                    disablePast: true,
                }),
                (0, common_1.makeAppointmentConflictsUiSchema)("futureAppointment"),
            ],
        },
        {
            type: "VerticalLayout",
            rule: {
                effect: "SHOW",
                condition: {
                    scope: "#/properties/action",
                    schema: { const: "CANCEL_VISIT" },
                },
            },
            elements: [
                {
                    type: "Control",
                    label: "Visit Date",
                    scope: "#/properties/visitDate",
                    options: {
                        format: "date",
                        disablePast: true,
                    },
                    rule: {
                        effect: "SHOW",
                        condition: {
                            scope: "#/properties/action",
                            schema: { const: "CANCEL_VISIT" },
                        },
                    },
                },
                {
                    type: domain_1.RenderersUIType.VisitPicker,
                    label: "Select Visit Time",
                    scope: "#/properties/visitToCancel",
                },
            ],
        },
        {
            type: "Control",
            label: "Notes",
            scope: "#/properties/notes",
        },
    ],
};
